//---------------------------------------------------------
// Imports
//---------------------------------------------------------
import {createTheme, CssBaseline, responsiveFontSizes, ThemeProvider} from '@mui/material';
import {QueryClientProvider} from '@tanstack/react-query';
import Layout from 'components/layout/Layout';
import ProtectedRoute from 'components/layout/ProtectedRoute';
import {queryClient} from 'hooks/marketHooks';
import HistoryPage from 'pages/HistoryPage';
import LoginPage from 'pages/LoginPage';
import ErrorPage from 'pages/ErrorPage';
import {ReactNode} from 'react';
import {Route, Routes} from 'react-router-dom';
import {RecoilRoot} from 'recoil';
import HomePage from './pages/HomePage';
import './root.css';
import ModalAlert from 'components/layout/ModalAlert';
import {outerTheme} from 'theme';
import {BrowserRouter} from 'react-router-dom';
import {Footer} from 'components/layout/Footer';
import {Header} from 'components/layout/Header';

//---------------------------------------------------------
// Component
//---------------------------------------------------------
export default function AppRoot() {
	let theme = createTheme(outerTheme);
	theme = responsiveFontSizes(theme);

	const WithAuth = (children: ReactNode) => <ProtectedRoute>{children}</ProtectedRoute>;

	return (
		<BrowserRouter>
			<ThemeProvider theme={theme}>
				<RecoilRoot>
					<CssBaseline />

					<QueryClientProvider client={queryClient}>
						<ModalAlert />

						<Routes>
							<Route path="/" element={WithAuth(<HomePage />)} />
							<Route path="/login" element={<LoginPage />} />
							<Route path="/history" element={WithAuth(<HistoryPage />)} />
							<Route path="/404" element={<ErrorPage />} />
							<Route path="/*" element={<ErrorPage />} />
						</Routes>
					</QueryClientProvider>
				</RecoilRoot>
			</ThemeProvider>
		</BrowserRouter>
	);
}
